var map = {
	"./company-growth.png": "1eca",
	"./decorator-light.png": "994c",
	"./decorator.png": "894b",
	"./education.png": "4f78",
	"./leading-strategy.png": "f834",
	"./personal-coaching.png": "5387",
	"./personal-development.png": "e3c6",
	"./professionality.png": "faf7",
	"./psychodiagnostic-methods.png": "24fa",
	"./sensible-hiring.png": "8c3e",
	"./simplicity.png": "d270"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";